(function () {
  function init() {
    var modal = document.getElementById('acjRecModal');
    var body = document.getElementById('acjRecBody');
    var title = document.getElementById('acjRecTitle');
    if (!modal || !body) return;

    async function openWith(url) {
      var u = url || '/pages/recomandari?view=recomandari-embed';
      if (title) title.textContent = 'Recomandări';

      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('acj-rec--noscroll');

      body.innerHTML = '<div style="padding:24px;">Se încarcă…</div>';

      try {
        var res = await fetch(u, { credentials: 'same-origin' });
        var html = await res.text();

        // extrage doar conținutul din <body>...</body>
        var m = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
        body.innerHTML = m ? m[1] : html;
      } catch (e) {
        body.innerHTML = '<div style="padding:24px;">Nu am putut încărca conținutul. Încearcă din nou.</div>';
      }
    }

    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('acj-rec--noscroll');
      body.innerHTML = '';
    }

    // CAPTURE: se execută înaintea altor click handlers
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a.recomandari-link');
      if (a) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var url = a.getAttribute('data-url') || a.dataset.url || '/pages/recomandari?view=recomandari-embed';
        openWith(url);
        return false;
      }

      if (e.target.closest('[data-acj-rec-close]')) {
        e.preventDefault();
        close();
      }
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
